module.exports = __webpack_public_path__ + "static/kdb-banner-3-29a20b53c148165f1c60ed62d2290879.webp";